import { render, staticRenderFns } from "./StaffBulkUpload.vue?vue&type=template&id=5254e34d&"
import script from "./StaffBulkUpload.vue?vue&type=script&lang=js&"
export * from "./StaffBulkUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports